var _this = this,
    _jsxFileName = "/builds/zillow/adtech-product/constellation/zrs-cms-messaging/src/img/NeighborhoodHelp.jsx";

import React from 'react';
import PropTypes from 'prop-types';

var NeighborhoodHelp = function NeighborhoodHelp(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "50",
    height: "50",
    viewBox: "0 0 100 100",
    xmlSpace: "preserve",
    className: className,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("defs", {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 13,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement("style", {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 14,
      columnNumber: 13
    }
  }, '.prefix__cls-1{fill:#ffd237}.prefix__cls-2{fill:#0d4599}.prefix__cls-3{fill:#006aff}.prefix__cls-4{fill:#a6e5ff}.prefix__cls-5{fill:#fff}')), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Layer_2",
    "data-name": "Layer 2",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 20,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Layer_1-2",
    "data-name": "Layer 1",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 21,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M96.14 69.54c-2.65-2-6 4.15-6 4.15s4.39-9.47.5-9.9c-1.62-.17-3.35 4-4.18 8 0-3.71-.94-6.8-2.26-6.94-3.89-.4-1.5 9.8-1.5 9.8l1 5.51h6.05s8.97-8.63 6.39-10.62z",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 22,
      columnNumber: 17
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-2",
    d: "M64.38 19.86L42.36 55.55l44.01.01-21.99-35.7z",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 26,
      columnNumber: 17
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-2",
    d: "M35.68 19.85h28.69v35.7H35.68z",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 27,
      columnNumber: 17
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-3",
    d: "M35.69 19.85L13.68 55.53l44 .02-21.99-35.7z",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 28,
      columnNumber: 17
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-4",
    d: "M35.69 23.76l-19.6 31.78 39.18.01-19.58-31.79z",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 29,
      columnNumber: 17
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-4",
    d: "M16.08 55.54h39.18v11.75H16.08z",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 33,
      columnNumber: 17
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-4",
    d: "M44.77 55.55h39.18V67.3H44.77z",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 34,
      columnNumber: 17
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-5",
    d: "M24.71 58.63h7.94v5.61h-7.94zM71.02 58.65h7.94v5.61h-7.94z",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 35,
      columnNumber: 17
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-3",
    d: "M16.08 67.29h67.87v12.85H16.08z",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 39,
      columnNumber: 17
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-2",
    d: "M33.89 67.29h31.15v12.85H33.89z",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 40,
      columnNumber: 17
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-3",
    d: "M52.3 46.34L39.55 67.29l25.49.01L52.3 46.34z",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 41,
      columnNumber: 17
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-3",
    d: "M46.64 46.34h5.66v5.3h-5.66z",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 42,
      columnNumber: 17
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-2",
    d: "M46.64 46.34L33.89 67.29l25.49.01-12.74-20.96z",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 43,
      columnNumber: 17
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-3",
    d: "M46.64 51.63l-7.54 12.5h15.07l-7.53-12.5z",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 47,
      columnNumber: 17
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-5",
    d: "M19.69 69.07h11.8v7.73h-11.8zM69.55 69.09h11.8v7.73h-11.8z",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 48,
      columnNumber: 17
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-2",
    d: "M33.89 67.2h25.49v12.94H33.89z",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 52,
      columnNumber: 17
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-3",
    d: "M45.88 67.29h1.5a3.5 3.5 0 013.5 3.5v9.34h-8.5V70.8a3.5 3.5 0 013.5-3.5z",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 53,
      columnNumber: 17
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-5",
    d: "M32.37 39.47h6.62v9.74h-6.62z",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 57,
      columnNumber: 17
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M20 64.07c0-3.75-2.88-18.89-9.77-16.06-2.22.91-4.09 4.3-5 6.29C2.94 59.31 1.9 70 7.57 73.47c2.9 1.78 7 .92 9.47-1.44A10.54 10.54 0 0020 64.07z",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 58,
      columnNumber: 17
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-3",
    d: "M11.25 58.34h1.2v21.67h-1.2z",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 62,
      columnNumber: 17
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h100v100H0z",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 63,
      columnNumber: 17
    }
  }))));
};

NeighborhoodHelp.propTypes = process.env.NODE_ENV !== "production" ? {
  className: PropTypes.string
} : {};
NeighborhoodHelp.defaultProps = {
  className: null
};
export default NeighborhoodHelp;